import { createSlice } from '@reduxjs/toolkit'

import { DEFAULT_TABLE } from '../../containers/database/constants'
import { getInitialFormData } from '../../containers/database/utils/tableHelpers'
import { databasePageSelectors } from '../selectors/databasePage'

const initialState = {
    selectedTable: DEFAULT_TABLE,
    formData: getInitialFormData(DEFAULT_TABLE),
    editingRowId: null,
    editRowData: {},
    showDeleteModal: false,
    deleteTargetRow: null,
}

const databasePage = createSlice({
    name: 'databasePage',
    initialState,
    reducers: {
        setSelectedTable: (state, action) => {
            state.selectedTable = action.payload
            state.formData = getInitialFormData(action.payload)
            state.editingRowId = null
            state.editRowData = {}
        },
        setFormData: (state, action) => {
            state.formData = action.payload
        },
        updateFormField: (state, action) => {
            const { field, value } = action.payload
            state.formData[field] = value
        },
        resetFormData: (state) => {
            state.formData = getInitialFormData(state.selectedTable)
        },
        startEditingRow: (state, action) => {
            state.editingRowId = action.payload.rowId
            state.editRowData = action.payload.rowData
        },
        cancelEditingRow: (state) => {
            state.editingRowId = null
            state.editRowData = {}
        },
        updateEditField: (state, action) => {
            const { field, value } = action.payload
            state.editRowData[field] = value
        },
        setDeleteModal: (state, action) => {
            state.showDeleteModal = action.payload.open
            state.deleteTargetRow = action.payload.row ?? null
        },
        resetPage: () => initialState,
    },
    selectors: {
        ...databasePageSelectors,
    },
})

export const databasePageSelector = databasePage.getSelectors()
export const databasePageActions = databasePage.actions

export default databasePage.reducer
